// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","container":"_1hrKmFwbpKHNWd8r8kz9EG _15-uIrn7gODHiOpUuDWjwC","dataLoaded":"_3U5va97zKBX_dSinv9zCfL","spinner":"_1EPG88TXNJHFuDlhOAgMFi"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/ProductDetail.css
// module id = 1053
// module chunks = 1